import { ThemeWithColors } from '@trustmary/form-styles'
import { useContext } from 'react'
import { ThemeContext } from '../context/themeContext'

export function useTheme(): ThemeWithColors {
  return useContext(ThemeContext)
}
